export const getters = {
  loggedIn: ({ loggedIn }) => loggedIn,
  user: ({ user }) => user,
  isInRole: ({ user }) => (role) => {
    return   role ? role.some(value => user.roles.split(',').includes(value)) : true
  },
}
